export default (function menuInit() {
    const post = {
        initHandlers() {
            const mob = window.matchMedia('(max-width: 767px)');
            function toogleSwitcher(mob) {
                const $commentForm = $('#commentInput');
                if (mob.matches) {
                    $commentForm.collapse('hide');
                    $commentForm.addClass('collapse');
                } else {
                    $commentForm.removeClass('collapse');
                    $commentForm.collapse('show');
                }
            }
            toogleSwitcher(mob);
            mob.addEventListener('change', () => toogleSwitcher(mob));
        }
    };
    $(document).ready(function () {
        post.initHandlers()
    })
})();